import { Crown, Lock } from 'lucide-react'

interface ProBadgeProps {
  size?: 'sm' | 'md'
}

export function ProBadge({ size = 'sm' }: ProBadgeProps) {
  return (
    <span className={`inline-flex items-center gap-1 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-medium rounded-full ${
      size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
    }`}>
      <Crown size={size === 'sm' ? 12 : 14} />
      PRO
    </span>
  )
}

interface ProFeatureLockProps {
  feature: string
  children: React.ReactNode
  onUpgrade?: () => void
}

export function ProFeatureLock({ children, onUpgrade }: ProFeatureLockProps) {
  return (
    <div className="relative">
      <div className="opacity-50 pointer-events-none select-none">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center bg-gray-900/5 rounded-lg backdrop-blur-[1px]">
        <button
          onClick={onUpgrade}
          className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-medium rounded-lg shadow-lg hover:from-amber-600 hover:to-orange-600 transition-all"
        >
          <Lock size={16} />
          <span>Upgrade to Pro</span>
        </button>
      </div>
    </div>
  )
}

interface UpgradePromptProps {
  title?: string
  description?: string
  onUpgrade?: () => void
}

export function UpgradePrompt({
  title = 'Upgrade to Pro',
  description = 'Unlock all premium features including auto-refresh, auto-delete, and NUKE capabilities.',
  onUpgrade
}: UpgradePromptProps) {
  return (
    <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 rounded-xl p-6 text-center">
      <div className="w-12 h-12 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
        <Crown className="w-6 h-6 text-white" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
      <button
        onClick={onUpgrade}
        className="px-6 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-medium rounded-lg hover:from-amber-600 hover:to-orange-600 transition-all"
      >
        Upgrade Now
      </button>
    </div>
  )
}
